








































































/* General */
import Vue from 'vue'
import MailboxSettingsLayout from '@/layouts/mailbox-settings-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { EEntities } from '@/types'
import {
  IStatusForSelection,
  IWorkflowForSelection,
} from '@/api/types/response.types'
import {
  IMailboxesInputChangeWorkflow,
  IStatusMapping,
} from '@/api/types/request.types'

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'
import WorkflowsAPI from '@/api/modules/workflows.api'

export default Vue.extend({
  name: 'MailboxSettingsManageWorkflow',

  metaInfo(): any {
    return {
      title: `Manage Workflow - ${this.name}`,
    }
  },

  components: {
    MailboxSettingsLayout,
    EntitySettingsLoading,
  },

  data() {
    return {
      EEntities,
      RouteAssistant,
      ColorAssistant,
      isEmptyMailbox: false,
      isLoading: true,
      isLoadingStatuses: false,
      isTogglingJobs: false,
      isJobsEnabled: false,
      isMappingStatuses: false,
      showCreateWorkflowDrawer: false,
      name: '',
      workflows: [] as IWorkflowForSelection[],
      hasDataReliantOnStatuses: true,
      newWorkflowID: null,
      currentWorkflowID: null,
      newWorkflowStatuses: [] as IStatusForSelection[],
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
    currentWorkflow(): IWorkflowForSelection {
      return this.workflows.find(w => w.id === this.currentWorkflowID)
    },
    newWorkflow(): IWorkflowForSelection {
      return this.workflows.find(w => w.id === this.newWorkflowID)
    },
    selectableWorkflows(): IWorkflowForSelection[] {
      return this.workflows.filter(w => w.id !== this.currentWorkflowID)
    },
    hasNewWorkflow(): boolean {
      return this.newWorkflowID !== null
    },
    currentWorkflowHasJobs(): boolean {
      return this.currentWorkflow.listJobs.length > 0
    },
  },

  watch: {
    isJobsEnabled: {
      immediate: false,
      async handler(val) {
        if (this.isLoading) {
          return
        }
        try {
          this.isTogglingJobs = true
          const response = await MailboxesAPI.put_ToggleJobs(this.id, val)
          this.isTogglingJobs = false
          this.$messaging.showSuccess(response.message)
        } catch (error) {
          this.$error.emit(error, true)
        }
      },
    },
  },

  async created() {
    this.isLoading = true
    await this.loadInitialData()
    this.isLoading = false
  },

  methods: {
    async loadInitialData() {
      await Promise.all([this.getWorkflowInfo(), this.getWorkflows()])
      this.newWorkflowID = null
    },
    isSelected(workflow: IWorkflowForSelection): boolean {
      return this.newWorkflowID === workflow.id
    },
    selectWorkflow(workflow: IWorkflowForSelection) {
      this.newWorkflowID = workflow.id
    },
    async handleWorkflowCreation(id: number) {
      await this.getWorkflows()

      const selectedWorkflow = this.workflows.find(w => w.id === id)
      const selectedIndex = this.workflows.findIndex(w => w.id === id)

      this.workflows.splice(selectedIndex, 1)
      this.workflows.unshift(selectedWorkflow)

      this.newWorkflowID = id
    },
    async getWorkflowInfo() {
      try {
        const response = await MailboxesAPI.get_WithWorkflow(this.id)
        this.name = response.title
        this.currentWorkflowID = response.workflowID
        this.hasDataReliantOnStatuses = response.hasDataReliantOnStatuses
        this.isJobsEnabled = response.isJobsEnabled
      } catch (error) {
        this.$error.emit(error)
      }
    },
    async getWorkflows() {
      try {
        const response = await MailboxesAPI.get_Workflows()
        this.workflows = response
      } catch (error) {
        this.$error.emit(error)
      }
    },
    async getStatuses() {
      try {
        this.isLoadingStatuses = true
        this.newWorkflowStatuses = await WorkflowsAPI.get_Statuses(
          this.newWorkflowID,
        )
        this.isMappingStatuses = true
      } catch (error) {
        this.$error.emit(error)
      } finally {
        this.isLoadingStatuses = false
      }
    },
    async changeWorkflow(statusMappings: IStatusMapping[]) {
      try {
        const data = {
          newWorkflowID: this.newWorkflowID,
          listStatusMappings: statusMappings,
        } as IMailboxesInputChangeWorkflow

        const response = await MailboxesAPI.put_ChangeWorkflow(this.id, data)
        this.$messaging.showSuccess(response.message)
        this.isMappingStatuses = false
        this.loadInitialData()
      } catch (error) {
        this.$error.emit(error, true)
        this.isMappingStatuses = false
      }
    },
  },
})
